'use client';
import { useEffect, useRef, useState } from 'react';

import { JobDetailsType } from '@/features/strapi/types';

import { AnchorArticle } from './AnchorArticle.component';
import styles from './AnchorArticles.module.scss';
import { AnchorNav } from './AnchorNav.component';

export const AnchorArticles = ({ content }: { content: JobDetailsType[] }) => {
    const [activeSection, setActiveSection] = useState(
        content.find((detail) => !!detail.anchor)?.anchor || ''
    );
    const [isMobile, setIsMobile] = useState(true);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const loadingRef = useRef<boolean | null>(null);

    const setNavActive = (id: string) => {
        loadingRef.current = true;
        setActiveSection(id);
    };

    const setScrollActive = (id: string) => {
        if (loadingRef.current) return;
        setActiveSection(id);
    };

    useEffect(() => {
        let timeout: NodeJS.Timeout;

        if (loadingRef.current && contentRef.current) {
            const duration =
                Math.min(Math.floor(contentRef.current.clientHeight / 900) * 300, 1000) || 300;
            timeout = setTimeout(() => {
                loadingRef.current = false;
            }, duration);
        }

        return () => clearTimeout(timeout);
    }, [activeSection]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section className={styles.wrapper}>
            <div className={styles.articles} ref={contentRef}>
                {content.map((detail) => (
                    <AnchorArticle
                        key={detail.id}
                        content={detail}
                        setActive={isMobile ? undefined : setScrollActive}
                    />
                ))}
            </div>
            {!isMobile && (
                <AnchorNav content={content} activeId={activeSection} setActive={setNavActive} />
            )}
        </section>
    );
};
